export const PERMISSION_NOT_ALLOW = 'PERMISSION_NOT_ALLOW';